const TABS_ID = {
  first: '1',
  second: '2',
};

const PAGE_PATHS = {
  information: '/limited-family',
  terms: '/limited-family/terms',
};

const POPUP_NAMES = {
  add: 'addNumber',
  addedSuccessfully: 'addedSuccessfully',
  notFoundError: 'notFoundError',
  diffRegionError: 'diffRegionError',
  error: 'error',
  delete: 'delete',
  deleteSuccess: 'deleteSuccess',
  terms: 'terms',
  success: 'success',
  cancelInvitation: 'cancelInvitation',
  saveLimits: 'saveLimits',
  limitsSavedSuccess: 'limitsSavedSuccess',
};

const INVITATION_STATUS = {
  sent: 'Sent',
  confirmed: 'Confirmed',
};

const LIMIT_UNITS = {
  Интернет: 'limitData',
  Звонки: 'limitTime',
  SMS: 'limitSMS',
  ctn: 'childCtn',
};

const ERROR_POPUP_TYPES = {
  CTN_NOT_FOUND: 'notFoundError',
  DIFFERENT_REGIONS_ABONENT: 'diffRegionError',
};

const LIMITS_IN_PROCESSING_TEXT = 'Лимиты в процессе установки';

const FAMILY_PRICING_PERIOD = {
  DAILY: '₽/сутки',
  MONTHLY: '₽/мес',
};

export {
  TABS_ID,
  POPUP_NAMES,
  INVITATION_STATUS,
  PAGE_PATHS,
  LIMIT_UNITS,
  ERROR_POPUP_TYPES,
  LIMITS_IN_PROCESSING_TEXT,
  FAMILY_PRICING_PERIOD,
};
